<template>
  <div class="card px-2 py-3 mb-3 shadow-sm d-flex">
    <div class="d-flex my-0">
      <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroup-sizing-sm"
            >Period</span
          >
        </div>
        <IndustrySearch
          class="form-control"
          :option_list="months"
          :default_values="monthSelected"
          :key="3"
          :multiple="false"
          @selected="selectMonth"
        />
      </div>

      <div
        class="w-25 input-group input-group-sm p-1 ml-3 treeselect-wrapper"
        v-if="oliverSalesLoaded"
      >
        <span class="loadingres spinner-border loading-spinner text-primary">
        </span>
      </div>

      <div
        class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
        v-if="!oliverSalesLoaded && userOliverSales.length > 1"
      >
        <div class="input-group-prepend">
          <span class="input-group-text" id="inputGroup-sizing-sm">Sale</span>
        </div>
        <IndustrySearch
          :option_list="userOliverSales"
          :default_values="userOliverSale"
          :key="3"
          :multiple="false"
          :isDisabled="savingOliverUser || isUserOliverSale"
          @selected="selectOliverSale"
          class="form-control inline-table"
        />
      </div>

      <div
        class="d-flex col-12 col-md-6 justify-content-end py-0 my-0"
        v-if="!loadingDataSale"
      >
        <span class="mx-0 p-0" v-if="saleRankingData.total">
          <img
            class="ml-1"
            :src="logoRevenueRanking(saleRankingData.total)"
            height="78px"
        /></span>
        <span class="mx-0" v-if="saleRankingData.avatar">
          <img
            class="ml-1 rounded-circle shadow"
            :src="saleRankingData.avatar"
            height="70px"
          />
        </span>
      </div>
    </div>

    <div
      class="d-flex flex-row justify-content-center py-0 my-0 w-100 pt-4"
      v-if="userOliverSale[0] == '0'"
    >
      <div class="col-lg-12 pt-2 text-center py-0">
        <img
          src="@/assets/images/search-oliver3.png"
          class="rounded mx-auto d-block py-0"
          width="180px"
        />
      </div>
    </div>

    <LoadingSpinner v-if="loadingData && userOliverSale[0] != '0'" />

    <!-- Data table -->
    <div class="col-12 mt-3" v-if="!loadingData && userOliverSale[0] != '0'">
      <div class="row">
        <div class="col-12">
          <Table
            :key="key"
            :headers="headers"
            :cols="cols"
            :data="data"
            :model="[]"
            :checkbox="false"
            :notselect="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usersService } from "@/_services";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import moment from "moment";
import { mapState } from "vuex";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "../LoadingSpinner.vue";

export default {
  name: "OliverSalesAchievements",

  components: {
    IndustrySearch,
    Table,
    LoadingSpinner,
  },

  data() {
    return {
      clients_signed: [
        {
          id: 1,
          img: "client5.png",
          label: "5 new clients signed this month",
          min: 5,
          max: 15,
        },
        {
          id: 2,
          img: "client15.png",
          label: "15 new clients signed this month",
          min: 16,
          max: 30,
        },
        {
          id: 3,
          img: "client30.png",
          label: "30 new clients signed this month",
          min: 31,
          max: 99999,
        },
      ],

      meetings_order: [
        {
          id: 1,
          img: "meetingsclient5.png",
          label: "5 meetings for an order this month",
          min: 5,
          max: 10,
        },
        {
          id: 2,
          img: "meetingsclient5.png",
          label: "10 meetings for an order this month",
          min: 11,
          max: 20,
        },
        {
          id: 3,
          img: "meetingclient10.png",
          label: "20 meetings for an order this month",
          min: 21,
          max: 99999,
        },
      ],

      orders: [
        {
          id: 1,
          img: "orders20.png",
          label: "20 orders sold in a month",
          min: 20,
          max: 40,
        },
        {
          id: 2,
          img: "orders40.png",
          label: " 40 orders sold in a month",
          min: 41,
          max: 60,
        },
        {
          id: 3,
          img: "orders60.png",
          label: "60 orders sold in a month",
          min: 61,
          max: 99999,
        },
      ],

      meetings_client: [
        {
          id: 1,
          img: "totalmeetings10.png",
          label: "10 meetings for a client",
          min: 10,
          max: 50,
        },
        {
          id: 2,
          img: "totalmeetings50.png",
          label: "50 meetings for a client",
          min: 51,
          max: 100,
        },
        {
          id: 3,
          img: "totalmeetings100.png",
          label: "100 meetings for a client",
          min: 101,
          max: 300,
        },
        {
          id: 4,
          img: "totalmeetings300.png",
          label: "300 meetings for a client",
          min: 301,
          max: 500,
        },
        {
          id: 5,
          img: "totalmeetings500.png",
          label: "500 meetings for a client",
          min: 501,
          max: 99999,
        },
      ],
      loadingDataSale: true,
      loadingData: false,
      userOliverSale: ["0"],
      //userOliverSales: [{ id: "0", label: "Select option..."}, { id: "all", label: "All"}],
      userOliverSales: [{ id: "0", label: "All" }],
      oliverSalesLoaded: false,
      savingOliverUser: false,
      monthSelected: ["0"],
      currentMonth: moment().month() + 1,
      months: [
        { id: "0", label: "Select option..." },
        { id: "01", label: "January" },
        { id: "02", label: "February" },
        { id: "03", label: "March" },
        { id: "04", label: "April" },
        { id: "05", label: "May" },
        { id: "06", label: "June" },
        { id: "07", label: "July" },
        { id: "08", label: "August" },
        { id: "09", label: "September" },
        { id: "10", label: "October" },
        { id: "11", label: "November" },
        { id: "12", label: "December" },
      ],
      monthsWithData: [],

      key: 3232323,
      data: [],
      headers: [
        {
          label: "Date",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 1,
        },
        {
          label: "Award",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 3,
        },
        {
          label: "Award name",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 4,
        },
        {
          label: "Sale",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        },
        {
          label: "Details",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
        },
      ],

      cols: [
        [
          {
            value: "date_selected",
          },
        ],
        [
          {
            value: "award_photo",
            type: "ImageBadge",
          },
        ],
        [
          {
            value: "award_name",
          },
        ],
        [
          {
            value: "name",
          },
        ],
        [
          {
            value: "detail",
          },
        ],
      ],
    };
  },

  created() {
    this.init();
    const currentoMonth = moment().month() + 1;
    this.months = this.months.filter((el) => el.id <= currentoMonth);
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    isUserOliverSale() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 2;
    },
  },

  methods: {
    init() {
      //this.getData()
      if (this.monthSelected[0] != "0") {
        this.getUserOliverSales(null, this.monthSelected[0]);
      }
    },

    getUserOliverSales(complete = 0, month) {
      this.oliverSalesLoaded = true;
      usersService
        .getUserOliverSales(true, true, this.monthSelected[0])
        .then((res) => {
          if (res.result.length > 0) {
            this.userOliverSales = [
              { id: "0", label: "Select option..." },
              { id: "all", label: "All" },
            ];
            const userOliverSalesWithlabel = res.result.map((el) => ({
              ...el,
              label: el.lastname + ", " + el.name,
            }));
            this.userOliverSales.push(...userOliverSalesWithlabel);
            this.oliverSalesLoaded = false;

            if (this.isUserOliverSale) {
              const findUserOliverSale = this.userOliverSales.find(
                (el) => el.id == this.user.id
              );
              if (findUserOliverSale) {
                this.userOliverSale = [findUserOliverSale.id];
                this.getData();
              }
            }
          }
        })
        .catch((err) => console.err(err));
    },

    selectMonth(value) {
      this.monthSelected[0] = value.id;
      if (value.id != 0) {
        (this.userOliverSale = ["0"]),
          this.getUserOliverSales(null, this.monthSelected[0]);
      }
    },

    selectOliverSale(value) {
      if (value.id != 0) {
        this.userOliverSale[0] = value.id;
        if (this.monthSelected[0] != "0") {
          this.loadingDataSale = true;
          this.getData();
        }
      }
    },

    addAwardData(item) {
      let award = this[item.label].find(
        (e) => Number(item.total) >= e.min && Number(item.total) <= e.max
      );
      if (item.label == "clients_signed") {
        award.detail = "";
      }
      if (item.label == "meetings_order") {
        award.detail =
          "Campaign: " + item.target_name + " (" + item.client_name + ")";
      }
      if (item.label == "orders") {
        award.detail = "";
      }
      if (item.label == "meetings_client") {
        award.detail = "Client: " + item.client_name;
      }
      return award;
    },

    getData() {
      this.data = [];
      this.loadingData = true;
      usersService
        .getOliverSalesAchievements(
          this.userOliverSale[0],
          this.monthSelected[0]
        )
        .then((res) => {
          if (res.result) {
            res.result.forEach((el) => {
              const { img, label, detail } = this.addAwardData(el);
              el.award_photo = img;
              el.award_name = label;
              el.detail = detail;
              el.name = el.lastname + ", " + el.name;
            });
            this.data = res.result;
            this.loadingData = false;
          }
        })
        .catch((err) => console.error(err));
    },
  },
};
</script>
